import { useState } from 'react'
import { Separator } from '@/components/ui/separator'
import { AppSidebar } from '@/layouts/dashboard/app-sidebar'
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar'

type Props = {
  children: React.ReactNode
}

export default function DashboardLayout({ children }: Props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  return (
    <SidebarProvider>
      <AppSidebar onSidebarOpen={setIsSidebarOpen} />
      <SidebarInset
        className={
          isSidebarOpen
            ? 'w-full min-w-0 md:w-[calc(100dvw-255px)]'
            : 'w-full min-w-0 md:w-[calc(100dvw-47px)]'
        }
      >
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
          </div>
        </header>
        <div className="min-w-0 px-3 pb-8 sm:px-6 md:px-12">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  )
}
